/** Exact single-article presentation, not a second body or FAQ owner. */
export const AI_OVERVIEWS_EXACT_SLUG = "track-ai-overview-impressions-google-search-console";
export const isAiOverviewsExactArticle = (slug: string) => slug === AI_OVERVIEWS_EXACT_SLUG;
export const AI_OVERVIEWS_PRESENTATION = {
  "faqIntroduction": "These questions separate visibility tracking, website measurement and implementation choices. Use each answer for its stated purpose, and check current product documentation before building a report around it. The aim is a repeatable decision process that buyers and reviewers can inspect, rather than a single score presented as commercial proof.",
  "commissioningContent": "## When should a B2B team involve an AI marketing agency?\n\nBring in an AI marketing agency when the team needs someone to connect technical fixes, useful content and commercial measurement with clear delivery ownership. Agree the buyer questions, page scope and reporting definitions first. The right engagement produces an actionable plan and accountable implementation, not simply another visibility dashboard.\n\nFor UK B2B teams, explore our [AI marketing strategy service](https://integrated.social/services/ai-marketing-strategy/) to connect buyer understanding with channel priorities. Use [SEO, AEO and GEO implementation support](https://integrated.social/services/seo-aeo-geo/) when the work requires technical search improvements, relevant content and measurement ownership.\n\n**Start with a readiness baseline:** [Check my AI visibility](https://integrated.social/free-ai-growth-audit/). The free score helps identify areas to review; it is separate from a paid diagnostic or implementation engagement.",
  "aliases": {
    "how-do-you-measure-the-impact-of-ai-overviews-on-website-traffic": [
      "what-ai-overviews-tracking-establishes"
    ],
    "check-technical-eligibility-before-rewriting-the-page": [
      "check-eligibility-before-changing-content",
      "indexing-snippets-inclusion-and-rendering"
    ],
    "what-does-google-search-console-show-about-ai-overviews": [
      "what-search-console-exposes",
      "fields-filters-and-aggregation"
    ],
    "how-do-you-track-visibility-for-specific-questions": [
      "save-buyer-questions-and-manual-observations",
      "exports-are-not-answer-samples"
    ],
    "run-one-documented-improvement-experiment": [
      "run-one-improvement-experiment",
      "baseline-change-repeat-decide",
      "copyable-google-test-worksheet"
    ],
    "when-should-a-b2b-team-involve-an-ai-marketing-agency": [
      "decide-what-to-fix-or-commission"
    ]
  },
  "cta": {
    "heading": "How ready is your website for AI search?",
    "body": "Get a free readiness baseline and a summary of areas to review. A deeper diagnostic and implementation plan are separate paid work.",
    "button": "Check my AI visibility",
    "url": "https://integrated.social/free-ai-growth-audit/"
  }
} as const;

/** Optional text only; never changes audit fields, handlers, scoring or delivery. */
export const AI_OVERVIEWS_AUDIT_COPY = {
  intro: "A high-level score across seven dimensions, followed by a PDF report by email.",
  priorityBenefit: "Priority areas to review for AI-search readiness",
  result: "Review your readiness score and the priority areas in your report. This baseline does not establish citations, rankings or commercial outcomes.",
  generationPdf: "Generating your PDF report…",
} as const;
